export default __webpack_public_path__ + "static/media/empty_list.ffdad94d.svg";